<ng-container *ngIf="bound$ | async as bound">
  <input
    type="radio"
    class="is-vishidden"
    aria-hidden="true"
    [attr.name]="boundType + '-selectedBound'"
    [checked]="bound.selected"
    [formControl]="control"
    [value]="bound"
    [attr.id]="inputId$ | async"
    (focusin)="bound.selected = true"
    (focusout)="bound.selected = false"
  />
  <label [for]="inputId$ | async" [attr.aria-labelledby]="ariaId$ | async"></label>
  <div
    class="bound-selection block rounded-large border overflow-hidden white-bg"
    [ngClass]="(selectedBorderColor$ | async) ? 'border-focus-3' : ''"
    [style.border-color]="selectedBorderColor$ | async"
    [style.outline-color]="selectedBorderColor$ | async"
    [attr.data-testid]="'bound-selection-selected-' + bound.selected || null"
  >
    <div
      *ngIf="campaignBadge$ | async as campaignBadge"
      class="heather-700-bg white-text medium-type align-center font-body-2 ps-xxsmall-y"
      data-testid="bound-special-offer-badge"
    >
      {{ campaignBadge | finLocalization }}
    </div>
    <div class="pr-xsmall-t pr-small-x">
      <fcom-ufo
        [arrival]="(ufoAirports$ | async)?.arrival"
        [departure]="(ufoAirports$ | async)?.departure"
        [tails]="tails$ | async | finTailNames"
        [isByBusOnly]="hasOnlyBusLegs$ | async"
        [airlines]="bound.details.uniqueAirlineNames"
        [duration]="bound.details.duration | finDuration | async"
        [stops]="bound.details.stops"
        [viewDetailsBtnKey]="viewDetailsBtnKey"
        [showViewDetails]="true"
        [flightNumbers]="(bound$ | async).details.itinerary | finFlightNumbers"
        (viewDetails)="openDetails($event, bound)"
      ></fcom-ufo>
    </div>
    <div class="pr-small-x" data-testid="new-flight-selection-notification">
      <ng-container
        [ngTemplateOutlet]="boundNotification"
        [ngTemplateOutletContext]="{ bound: bound, compact: true }"
      ></ng-container>
    </div>
    <div class="pr-xsmall-t">
      <fin-fare-family-list
        data-testid="fare-family-list"
        [id]="'fare-family-' + bound.details.id"
        [fareFamilies$]="fareFamilies$"
        [currencyCode]="currencyCode$ | async"
        [showUpsellCard]="true"
        [showKoreaNotification]="false"
        [isShowTotalPrice]="false"
        [isShortHaul$]="isShortHaul$"
        [isLongHaulLegAndAy$]="isLongHaulLegAndAy$"
        [preSelectedFareFamilyId]="preSelectedFareFamilyId$ | async"
        [enableFareFamilyAutoScroll$]="enableFareFamilyAutoScroll$"
        (selectFareFamily)="selectFareFamily.emit($event)"
        (openCabinClassModal)="openCabinClassModal.emit($event)"
        (cabinIsExpanded)="handleCabinExpanding($event)"
        (fareFamilyAutoScrolled)="cabinAutoScrolled()"
      >
      </fin-fare-family-list>
    </div>
  </div>
  <span class="is-vishidden" [attr.id]="ariaId$ | async">{{
    'ticketSelection.aria.boundInformation'
      | finLocalization
        : {
            departureLocationCode: bound.details.departure.locationCode,
            departureDate: bound.details.departure.dateTime | finDateFormat: 'FULL_NO_YEAR',
            departureTime: bound.details.departure.dateTime | finTime,
            arrivalLocationCode: bound.details.arrival.locationCode,
            arrivalDate: bound.details.arrival.dateTime | finDateFormat: 'FULL_NO_YEAR',
            arrivalTime: bound.details.arrival.dateTime | finTime,
            stops: bound.details.stops,
            priceStartingFrom: bound$ | finMap: 'cheapestPrice' | finOffersPrice: currencyCode$ | async,
            operatingAirlineNames: bound.details.uniqueAirlineNames | finJoin: ', ',
          }
  }}</span>
</ng-container>
<ng-template #boundNotification let-bound="bound" let-compact="compact">
  <fcom-notification
    *ngIf="hasBusLeg$ | async"
    class="mr-xsmall-t bound-selection-notes"
    [theme]="NotificationTheme.SUSTAINABILITY"
    [iconCategory]="IconLibrary.SVG_LIBRARY"
    [iconName]="SvgLibraryIcon.SUSTAINABILITY"
    [linkUrl]="'routeNotification.sustainabilityLink.url' | finLocalization"
    [linkText]="'routeNotification.sustainabilityLinkText' | finLocalization"
    [linkOpenInNewWindow]="true"
    [compact]="compact"
  >
    <span *ngIf="priorityServicesAvailable$ | async">
      {{ 'routeNotification.sustainableRoute' | finLocalization }}</span
    >
    <span *ngIf="(priorityServicesAvailable$ | async) === false">
      {{ 'routeNotification.sustainableRouteNoPriorities' | finLocalization }}
    </span>
  </fcom-notification>

  @if (hasTrainSegment$ | async) {
    <fcom-notification
      class="mr-xsmall-t bound-selection-notes"
      [theme]="NotificationTheme.INFO"
      [iconCategory]="IconLibrary.SVG_LIBRARY"
      [iconName]="SvgLibraryIcon.TRAIN"
      [linkUrl]="'routeNotification.containsTrainSegment.link.url' | finLocalization"
      [linkText]="'routeNotification.containsTrainSegment.linkText' | finLocalization"
      [linkOpenInNewWindow]="true"
      [compact]="compact"
    >
      <span>
        {{ 'routeNotification.containsTrainSegment.description' | finLocalization }}
      </span>
    </fcom-notification>
  }

  <fcom-notification
    *ngIf="bound.details.notes?.length > 0"
    class="mr-xsmall-t bound-selection-notes"
    [theme]="NotificationTheme.WARNING"
    [compact]="compact"
  >
    <span *ngFor="let note of bound.details.notes; let last = last"
      >{{ 'ticketSelection.notes.' + note | finLocalization }}<span *ngIf="!last">, </span></span
    >
  </fcom-notification>
</ng-template>
